module.exports = __webpack_public_path__ + "static/media/1.c01c6697.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16105/1.jpg
// module id = 536
// module chunks = 0